import { render, staticRenderFns } from "./billNoticeResultWindow.vue?vue&type=template&id=670d37dd&"
import script from "./billNoticeResultWindow.vue?vue&type=script&lang=js&"
export * from "./billNoticeResultWindow.vue?vue&type=script&lang=js&"
import style0 from "./billNoticeResultWindow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('670d37dd')) {
      api.createRecord('670d37dd', component.options)
    } else {
      api.reload('670d37dd', component.options)
    }
    module.hot.accept("./billNoticeResultWindow.vue?vue&type=template&id=670d37dd&", function () {
      api.rerender('670d37dd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Clearing/BillOverseasSCenter/components/billNoticeResultWindow.vue"
export default component.exports